import cx from "classnames";
import iFrameResizer, { IFrameMessageData } from "iframe-resizer";
import styles from "./NudgeShared.module.scss";

type LoginCtaProps = {
  includeText: boolean;
  source: string;
};

export const LoginCta = ({ includeText, source }: LoginCtaProps) => {
  //format the source name for analytics, which uses gateway instead of gate
  const actionName = source === "gate" ? "gate" : "nudge";

  const closeModal = () => {
    const modalElem = document.querySelector(".c-accounts-modal");
    modalElem && modalElem.remove();
  };

  const messageCallback = ({ message }: IFrameMessageData) => {
    switch (message.type) {
      case "SUCCESS":
        location.reload();
        break;

      case "CLOSE":
        closeModal();
        break;
    }
  };

  const modalHandler = () => {
    const modalElem = document.createElement("div");
    modalElem.className = "c-accounts-modal";
    modalElem.classList.add(styles.modalContainer);

    const iFrameElem = document.createElement("iframe");
    iFrameElem.src = "https://accounts.theatlantic.com/login/modal/";
    iFrameElem.title = "Login Modal";
    iFrameElem.id = "accounts-modal";
    iFrameElem.classList.add(styles.modalContent);

    modalElem.appendChild(iFrameElem);
    document.body.append(modalElem);
    iFrameResizer.iframeResizer(
      {
        log: false,
        messageCallback,
      },
      "#accounts-modal"
    );
  };

  return (
    <>
      {includeText && <span>Already a subscriber?</span>}
      <button
        className={styles.signinLink}
        data-testid="signin-link"
        data-action={`${actionName}:click_login`}
        data-label={source}
        onClick={modalHandler}
      >
        Sign in
      </button>
    </>
  );
};

type PrimaryLinkProps = {
  text: string;
  source: string;
  count?: number;
  isExpandedStyles: boolean;
  isCentered?: boolean;
  mobileOnly?: boolean;
};

export const PrimaryLink = ({
  text,
  source,
  count,
  isExpandedStyles,
  isCentered = false,
  mobileOnly = false,
}: PrimaryLinkProps) => {
  //format the source name for analytics, which uses gateway instead of gate
  const sourceName =
    source === "gate" ? "gateway:click_see_plans" : "nudge:click_subscribe";
  const linkName = source === "gate" ? source : "nudge";
  return (
    <a
      href={`https://accounts.theatlantic.com/products/?source=${linkName}${
        count ? count : ""
      }`}
      data-testid="subscribe-cta"
      data-action={sourceName}
      data-label={source}
      className={cx(
        styles.button,
        mobileOnly && styles.mobileOnly,
        isCentered && styles.centered,
        isExpandedStyles ? styles.expandedLink : styles.compressedLink
      )}
    >
      {text}
    </a>
  );
};
